export default __webpack_public_path__ + "static/media/team-member-1.dc793b64.png";